var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":"缺陷统计"}},[_c('custom-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }